import adminMenuItems from "@/layouts/main/adminNavMenuItems.js";
import Vue from "vue";


const filterSubItems = (items) => {
    const res = items.filter(
        (item) =>
            item.permission === null || Vue.prototype.hasPermission(item.permission)
    );
    return res;
}

const flattenSidebarItems = (items) => {
    return (items.map(e => e.header ? e.items : (e.submenu ? e.submenu : e))).flatten();
};

const flattenServices = (sidebars) => {
    return sidebars.map(e => flattenSidebarItems(e.sidebarItems)).flatten();
}

export default {
    namespaced: true,
    state: () => ({

        services: [{
            name: "Admin",
            icon: "HomeIcon",
            sidebarItems: adminMenuItems,
            hasVenueSelect: false,
            hasListManagement: false,
            idx: 0,
        },],
        currentServiceIdx: 0,
    }),
    mutations: {
    },
    actions: {
    },
    getters: {
        currentServiceIdx: state => state.currentServiceIdx,
        currentService: state => state.services[state.currentServiceIdx],
        currentMenuHasListManagement: state => state.services[state.currentServiceIdx].hasListManagement,
        services: state => state.services,
        servicesWithPermission: state => state.services.filter(e => {
            return flattenSidebarItems(e.sidebarItems).some(i => Vue.prototype.hasPermission(i.permission));
        }),
        currentServiceHasListManagement: state => state.services[state.currentServiceIdx].hasListManagement,
        currentSidebarItems: (state) => {
            let items = state.services[state.currentServiceIdx].sidebarItems.filter(
                (item) =>
                    item.permission === null ||
                    item.header || Vue.prototype.hasPermission(item.permission)
            );

            const itemsFiltered = items
                .map((e) => {
                    if (e.header) {
                        return { ...e, items: filterSubItems(e.items) };
                    } else if (e.submenu) {
                        return { ...e, submenu: filterSubItems(e.submenu) };
                    } else {
                        return e;
                    }
                })
                .filter((e) => (e.items ? e.items.length > 0 : true));
            return itemsFiltered
        },
        firstSidebarItem: (state, getters) => {
            const items = flattenSidebarItems(getters.currentSidebarItems);
            return (items)[0];
        },
        firstServiceWithSidebarItems: (state) => {
            var items = flattenServices(state.services).filter(e => Vue.prototype.hasPermission(e.permission))
            if (items.length > 0) {
                return items[0]
            } else return null;
        }
    }
};
